import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../account/AuthContext';
import ApiService from '../services/ApiService';
import { setToken } from '../utils/token';

const GuestModal = ({ isOpen, onClose, onContinueAsGuest }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await ApiService.login(email, password);
            if (response.success) {
                setToken(response.token);
                login(response.token, response.user.email);
                // Event 'userLoggedIn' wysłany automatycznie w AuthContext.login()

                onClose();
                navigate('/quote/order');
            } else {
                setError(response.message || 'Błąd logowania');
            }
        } catch (err) {
            setError('Wystąpił błąd podczas logowania');
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onClose();
        }
    };

    return (
        <div
        className="modal-overlay"
        onClick={handleBackdropClick}
        onKeyDown={handleKeyDown}
        tabIndex={-1}
        >
        <div className="modal-content-guest">
        <div className="auth-container">
        {/* Panel logowania - lewa strona */}
        <div className="auth-form-panel">
        <h2 className="auth-form-title">Masz już konto? Zaloguj się</h2>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleLogin}>
        <div className="auth-form-group">
        <label className="auth-form-label">Adres e-mail</label>
        <input
        type="email"
        className="auth-form-input"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        disabled={isLoading}
        />
        </div>

        <div className="auth-form-group">
        <label className="auth-form-label">Hasło</label>
        <input
        type="password"
        className="auth-form-input"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        disabled={isLoading}
        />
        </div>

        <button
        className="auth-submit-btn"
        type="submit"
        disabled={isLoading}
        >
        {isLoading ? 'LOGOWANIE...' : 'ZALOGUJ'}
        </button>
        </form>

        <Link to="/forgotpass" className="auth-forgot-link" onClick={onClose}>
        Zapomniałem hasła
        </Link>
        </div>

        {/* Panel rejestracji i benefitów - prawa strona */}
        <div className="auth-benefits-panel">
        <h2 className="auth-benefits-title">Nie masz konta? Załóż je teraz!</h2>
        <p className="auth-benefits-subtitle">Korzyści z posiadania konta:</p>

        <ul className="auth-benefits-list">

        <li className="auth-benefits-item"><span className="auth-benefits-icon">📤</span> Większy limit plików (do 100 MB)</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">⚙</span> Zaawansowane opcje konfiguracji druku</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">🚀</span> Szybsze składanie kolejnych zamówień</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">📋</span> Historia wszystkich zamówień</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">💾</span> Zapisane dane adresowe</li>
        <li className="auth-benefits-item"><span className="auth-benefits-icon">📊</span> Śledzenie statusu zamówień</li>
        </ul>

        {/* Sekcja rejestracji */}
        <div className="auth-register-section">
        <Link to="/register" className="auth-register-btn" onClick={onClose}>
        ZAŁÓŻ BEZPŁATNE KONTO
        </Link>
        </div>

        {/* Opcja kontynuowania jako gość */}
        <div className="guest-continue-section">
        <button
        className="guest-continue-btn"
        onClick={onContinueAsGuest}
        >
        Kontynuuj jako gość
        </button>
        </div>
        </div>
        </div>
        </div>
        </div>
    );
};

export default GuestModal;
